import styles from './SegmentsHeader.module.scss';

export const SegmentsHeader = () => (
  <div className={styles.container}>
    <h3 className={styles.title}>Segmentos personalizados</h3>
    <p className={styles.subtitle}>
      Crie e use agrupamentos que poderão ser usados como filtros em nossos produtos, conforme as suas necessidades de pesquisa.
    </p>
  </div>
);
